<template>
  <transition name="app-confirm-fade">
    <div v-if="visible" class="app-confirm-mask" @click.self="onCancel">
      <div class="app-confirm-panel" role="dialog" aria-modal="true">
        <button type="button" class="app-confirm-close" aria-label="关闭" @click="onCancel">
          <i class="el-icon-close" />
        </button>

        <div class="app-confirm-head">
          <div class="app-confirm-icon" :class="'icon-' + type">
            <i :class="iconClass" />
          </div>
          <h3 class="app-confirm-title">{{ title }}</h3>
        </div>

        <div class="app-confirm-body">
          <p v-if="message" class="app-confirm-message">{{ message }}</p>
          <div v-if="details && details.length" class="app-confirm-details">
            <div
              v-for="(row, idx) in details"
              :key="idx"
              class="app-confirm-detail-row"
              :class="{ 'is-danger-detail': row.danger }"
            >
              <span class="detail-label">{{ row.label }}</span>
              <span class="detail-value">{{ row.value }}</span>
            </div>
          </div>
        </div>

        <div class="app-confirm-footer">
          <button type="button" class="app-confirm-btn btn-ghost" @click="onCancel">
            {{ cancelText }}
          </button>
          <button type="button" class="app-confirm-btn" :class="'btn-' + type" @click="onConfirm">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AdminConfirmDialog',
  data() {
    return {
      visible: false,
      title: '提示',
      message: '',
      details: [],
      type: 'warning',
      confirmText: '确定',
      cancelText: '取消',
      resolve: null,
      reject: null
    }
  },
  computed: {
    iconClass() {
      const map = {
        warning: 'el-icon-warning-outline',
        danger: 'el-icon-delete',
        info: 'el-icon-info',
        success: 'el-icon-circle-check'
      }
      return map[this.type] || map.warning
    }
  },
  methods: {
    open(options = {}) {
      this.title = options.title || '提示'
      this.message = options.message || ''
      this.details = Array.isArray(options.details) ? options.details : []
      this.type = options.type || 'warning'
      this.confirmText = options.confirmText || options.confirmButtonText || '确定'
      this.cancelText = options.cancelText || options.cancelButtonText || '取消'
      this.visible = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close() {
      this.visible = false
      this.resolve = null
      this.reject = null
    },
    onConfirm() {
      const fn = this.resolve
      this.close()
      if (fn) fn(true)
    },
    onCancel() {
      const fn = this.reject
      this.close()
      if (fn) fn('cancel')
    }
  }
}
</script>

<style scoped>
.app-confirm-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
}

.app-confirm-panel {
  position: relative;
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.app-confirm-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #888;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-confirm-close:hover {
  background: #f5f5f5;
  color: #121212;
}

.app-confirm-head {
  padding: 22px 22px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-confirm-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.icon-warning {
  background: #fff8e8;
  color: #a86808;
}

.icon-danger {
  background: #fff5f5;
  color: #c0392b;
}

.icon-info {
  background: #f5f5f5;
  color: #555;
}

.icon-success {
  background: #f3faf6;
  color: #1e8f4a;
}

.app-confirm-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111;
  line-height: 1.4;
  padding-right: 28px;
}

.app-confirm-body {
  padding: 12px 22px 8px;
}

.app-confirm-message {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #555;
}

.app-confirm-details {
  margin-top: 12px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 2px 0;
  overflow: hidden;
}

.app-confirm-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 12px;
  border-bottom: 1px solid #efefef;
  font-size: 13px;
  line-height: 1.5;
}

.app-confirm-detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  flex-shrink: 0;
  width: 72px;
  color: #888;
}

.detail-value {
  flex: 1;
  color: #111;
  word-break: break-all;
}

.app-confirm-detail-row.is-danger-detail .detail-label,
.app-confirm-detail-row.is-danger-detail .detail-value {
  color: #dc2626;
  font-weight: 600;
}

.app-confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 22px 18px;
  border-top: 1px solid #e8e8e8;
  background: #fafafa;
}

.app-confirm-btn {
  min-width: 88px;
  height: 36px;
  padding: 0 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
}

.btn-ghost {
  background: #fff;
  color: #555;
  border-color: #d0d0d0;
}

.btn-ghost:hover {
  background: #fafafa;
  border-color: #b0b0b0;
  color: #333;
}

.btn-warning {
  background: #c47a0a;
  border-color: #c47a0a;
  color: #fff;
}

.btn-warning:hover {
  background: #a86808;
  border-color: #a86808;
}

.btn-danger {
  background: #c0392b;
  border-color: #c0392b;
  color: #fff;
}

.btn-danger:hover {
  background: #a93226;
  border-color: #a93226;
}

.btn-info {
  background: #121212;
  border-color: #121212;
  color: #fff;
}

.btn-info:hover {
  background: #2a2a2a;
  border-color: #2a2a2a;
}

.btn-success {
  background: #1f9d55;
  border-color: #1f9d55;
  color: #fff;
}

.btn-success:hover {
  background: #188a49;
  border-color: #188a49;
}

.app-confirm-fade-enter-active,
.app-confirm-fade-leave-active {
  transition: opacity 0.15s ease;
}

.app-confirm-fade-enter,
.app-confirm-fade-leave-to {
  opacity: 0;
}
</style>
